// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__2YXL9","rootSuccess":"CompleteLink_rootSuccess__1FWxf","rootFailure":"CompleteLink_rootFailure__1OYMN","isDisabled":"CompleteLink_isDisabled__3zGLY"};